import React from 'react';
import Layout from '../../components/UI/Layout/Layout';
import AuctionFeesList from '../../components/Entity/AuctionFees/AuctionFeesList';

const AuctionFeesPage = () => {
  return (
    <Layout>
      <AuctionFeesList />
    </Layout>
  );
};

export default AuctionFeesPage;
